import { ContentBox as ContentBoxRoot } from './content-box';
import { ContentBoxFooter } from './content-box-footer';
import { ContentBoxMain } from './content-box-main';

export const ContentBox = {
  Root: ContentBoxRoot,
  Main: ContentBoxMain,
  Footer: ContentBoxFooter,
};

export type { ContentBoxProps } from './types';
